export default {
  namespaced: true,
  getters: {
    info(state) {
      return state.info;
    },
  },
  state: {
    info: {
      name: 'test',
      age: 31,
      title: 'test',
      avatar:
        'https://baike-med-1256891581.file.myqcloud.com/mini_lite/production/static/luoshi/public/empty-doctor.png',
    },
  },
  mutations: {
    set(state, info) {
      state.info = info;
    },
  },
  actions: {},
};
